export default [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavItem',
          name: 'Dashboard',
          to: '/dashboard',
          icon: 'cil-speedometer'
        },
        {
          _name: 'CSidebarNavTitle',
          _children: ['Funktionen']
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Bestellen',
          to: '/order/Order',
          icon: 'cil-basket',
  
        }
        
      ]
    }
  ]